module.exports = __webpack_public_path__ + "img/gold2.d1a96ac3.png";